import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrowGeo.icon-16c745",
  "use": "arrowGeo.icon-16c745-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"arrowGeo.icon-16c745\"><path d=\"M30 10l-20 8.368v1.1l7.592 2.94L20.532 30h1.1z\" fill=\"var(--svg-primary-color)\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol